import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '../translation/translate.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  messageIsShown = false;

  selectedCustomPage = new BehaviorSubject<any>(null);
  currentSelectedCustomPage = this.selectedCustomPage.asObservable();

  constructor(
    private snackBar: MatSnackBar,
    private translateService: TranslateService
  ) {}

  setCurrentSelectedCustomPage(page: any) {
    this.selectedCustomPage.next(page);
  }

  showErrorMessage(messageKey: string, field: string, errorMessage: string) {
    this.messageIsShown = true;
    const snack = this.snackBar.open(
      messageKey,
      this.translateService.get('SNACKBAR.GOT_IT', {
        name: field,
        error: errorMessage,
      }),
      {
        duration: 10000,
        horizontalPosition: 'start',
        verticalPosition: 'bottom',
        panelClass: ['error' + '-snackbar', 'custom-snackbar'],
      }
    );
    snack.afterDismissed().subscribe(() => (this.messageIsShown = false));
  }

  public showCustomMessage(
    messageKey: string,
    headline: string,
    type?: 'success-snackbar' | 'error-snackbar'
  ): void {
    this.messageIsShown = true;

    const message = `${headline ? this.translateService.get(headline) : ''}
    ${this.translateService.get(messageKey)}`;

    const panelClass = type
      ? [type, 'custom-snackbar'] // ✅ If type is provided, override everything else
      : [
          headline === 'SNACKBAR.MESSAGE.SAVED'
            ? 'success-snackbar'
            : 'error-snackbar',
          'custom-snackbar',
        ]; // ✅ Default behavior when type is not provided

    const snack = this.snackBar.open(
      message,
      this.translateService.get('SNACKBAR.GOT_IT'),
      {
        duration: 10000,
        horizontalPosition: 'start',
        verticalPosition: 'bottom',
        panelClass: panelClass, // ✅ Apply the panel class
      }
    );

    snack.afterDismissed().subscribe(() => (this.messageIsShown = false));
  }
}
